import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { ComparisonNotification } from './components/ComparisonNotification';
import { ComparisonControl } from './components/ComparisonControl/ComparisonControl';
import { jsx as _jsx } from "react/jsx-runtime";
export var NOTIFICATION_EXPIRATION_DELAY = 15000;
export var CompareNotificationContainer = function CompareNotificationContainer(_ref) {
  var notification = _ref.notification,
    clearNotification = _ref.clearNotification;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    timeoutId = _React$useState2[0],
    setNotificationTimeout = _React$useState2[1];
  React.useEffect(function () {
    setNotificationTimeout(setTimeout(function () {
      clearNotification();
    }, NOTIFICATION_EXPIRATION_DELAY));
    return function () {
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
      }
    };
  }, [notification]);
  var handleLinkClick = React.useCallback(function () {
    setNotificationTimeout(setTimeout(function () {
      clearNotification();
    }, NOTIFICATION_EXPIRATION_DELAY));
  }, [notification]);
  var handleClose = React.useCallback(function () {
    clearNotification();
  }, []);
  var handleMouseEnter = React.useCallback(function () {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
  }, [timeoutId]);
  if (!notification || !notification.text) {
    return null;
  }
  return /*#__PURE__*/_jsx(ComparisonNotification, {
    control: /*#__PURE__*/_jsx(ComparisonControl, {
      url: notification.url,
      handleLinkClick: handleLinkClick,
      handleClose: handleClose
    }),
    text: notification.text,
    onMouseEnter: handleMouseEnter
  });
};